import { ReactNode } from "react";

import PageWrapper from "components/PageWrapper";
import PageInfoHeader from "ds/components/PageInfoHeader";

type SelfHostedUsageExportPageLayoutProps = {
  children: ReactNode;
};

const SelfHostedUsageExportPageLayout = ({ children }: SelfHostedUsageExportPageLayoutProps) => {
  return (
    <>
      <PageInfoHeader title="Usage export" />
      <PageWrapper limitWidth="medium">{children}</PageWrapper>
    </>
  );
};

export default SelfHostedUsageExportPageLayout;
